import React from "react";
import Workingsteps from "./WorkingSteps";
import MobileSteps from "./MobileSteps";
import "./ProcessPage.css";
import MobileStep1 from "../images/MobileStep1.svg";
import MobileStep2 from "../images/MobileStep2.svg";
import MobileStep3 from "../images/finanical-statement-step-3-mobile.svg";
import bottom3 from "../images/bottom3.svg";
const s3url = process.env.REACT_APP_ASSETS_CL_URL;
const steps = [
  {
    step: "Step 1",
    title: "Upload Statements",
    desc: "Add savings or current account PDFs in seconds, or connect via API.",
    img: `${s3url}/Financial Statement Step 1.gif`,
    mobileImg: MobileStep1,
  },
  {
    step: "Step 2",
    title: "Run Smart Checks",
    desc:
      "Every transaction is reviewed to calculate balances, track EMIs, and flag risks.",
    img: `${s3url}/Financial Statement Step 2.gif`,
    mobileImg: MobileStep2,
  },
  {
    step: "Step 3",
    title: "Get Decision-Ready Reports",
    desc:
      "Receive clear, accurate reports with insights that support faster approvals.",
    img: `${s3url}/Financial Statement Step 3.gif`,
    mobileImg: MobileStep3,
  },
];

function ProcessPage() {
  return (
    <div className="top-process-page">
      <div className="top-curve-section">
        <img src="/images/Rectangle (3).svg" alt="" />
      </div>
      <div className="process-page">
        <div className="process-header">
          <div className="process-title">
            <h1>
              From Upload to Decision in
              <span> Three Steps</span>
            </h1>
            {/* <h1>Tamper Checks Built in.</h1> */}
            <img src="" alt="" className="underLine" />
            <img src="" alt="" className="underLine1" />
          </div>
          <p className="process-subtitle">
            Reviewing bank account statements is now simple. Upload, detect
            risks, and get decision-ready reports instantly.
          </p>
        </div>
        <div className="process-steps-desktop">
          <Workingsteps steps={steps} />
        </div>
        <div className="process-steps-mobile">
          <MobileSteps steps={steps} />
        </div>
        <img src={bottom3} alt="bottom_3" className="bounce-bottom-2" />
      </div>
    </div>
  );
}

export default ProcessPage;
